// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { SxProps } from '@mui/system';

import MBDialog from 'components/Elements/MBDialog';
import { theme } from 'theme';

// default the zIndex to 39 to overlay the generic Create Project dialog
// z-index: 9999999 - to overlay "Help/Chat" button on mobile devices
export const Dialog = styled(MBDialog)`
  ${({ theme }) => theme.breakpoints.down('md')} {
    z-index: 9999999;
  }

  & .MuiPaper-root {
    ${({ theme }) => theme.breakpoints.down('md')} {
      border-radius: 20px 20px 0 0 !important;
    }
    ${({ theme }) => theme.breakpoints.up('md')} {
      max-width: 480px !important;
    }
  }

  & .MuiDialogContent-root {
    margin-bottom: 0;
  }

  z-index: 39;
`;

export const dialogTitle: SxProps = {
  '&&': {
    [theme.breakpoints.down('md')]: {
      fontSize: '20px !important',
      maxWidth: '80%',
    },
  },
};

export const leftButton: SxProps = {
  marginRight: 'unset !important',
  flexShrink: 0,

  '&:hover, &:active, &:focus': {
    boxShadow: 'none',
    backgroundColor: theme.palette.secondary.light,
  },
};

export const applyButton: SxProps = {
  flexShrink: 0,

  '&:hover, &:active, &:focus': {
    backgroundColor: theme.palette.grey['A700'],
  },
};

export const cancelButton: SxProps = {
  flexShrink: 0,

  '&:hover, &:active, &:focus': {
    boxShadow: 'none',
    backgroundColor: theme.palette.secondary.light,
  },
};

export const contentContainer: SxProps = {
  paddingTop: '8px',
};

export const Disclaimer = styled.p`
  font-size: 10px;
  margin-right: 4px;
  margin-bottom: 0;
  color: ${({ theme }) => theme.palette.grey['A400']};
`;
